import { ReactComponent as Alert } from '../assets/alert-icon.svg';

const ErrorModal = ({ state, dispatch }) => {
  const { errorMessage } = state;

  const handleClose = () => {
    dispatch({ type: 'SET_SHOW_ERROR_MODAL', payload: false });
  };

  return (
    <div className="error-modal w-full h-full bg-black flex items-center justify-center absolute top-0 left-0 z-[999999999] bg-black bg-opacity-50">
      <div className="bg-white rounded-lg max-w-[500px] max-h-[300px] flex flex-col gap-2 items-center p-4">
        <Alert />
        <b className='text-2xl'>Oops!</b>
        <p className='max-w-96 my-4 text-center'>{errorMessage}</p>
        <button
          className='rounded-full border-solid border-2 py-2 px-4 cursor-pointer'
          onClick={() => handleClose()}
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default ErrorModal